
import Popup from 'vux/src/components/popup/index.vue'

import mapUtil from '@/javascript/mapUtil'

export default {
name: 'mapList',
components: {
Popup
},
props: {
isShowMapList: {
type: Boolean,
default: false
},
guideData: {
type: Object
},
isWork: {
type: Boolean,
default: true
}
},
data() {
return {
gdMapUrl: "",
txMapUrl: "",
bdMapUrl: ""
}
},
mounted() {
this.setUrl()
},
watch: {
guideData: {
handler() {
this.setUrl()
},
deep: true
}
},
methods: {
setUrl: function(){
if(!this.isWork) return;
mapUtil.locate((data) => {
this.gdMapUrl = "http://uri.amap.com/navigation?from="+ data.position.lng + "," + data.position.lat + ",我的位置&to=" + this.guideData.longitude + "," + this.guideData.latitude + "," + this.guideData.title + "&mode=car&policy=1&src=mypage&callnative=0"
this.txMapUrl = "https://map.qq.com/nav/drive#routes/page?eword=" + data.formattedAddress + "&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start="+ data.position.lng + "," + data.position.lat + "&dest=" + this.guideData.latitude + "," + this.guideData.longitude + "&sword=我的位置"
this.bdMapUrl = "http://api.map.baidu.com/direction?origin=latlng:" + data.position.lat + "," + data.position.lng + "|name:我的起点&destination=latlng:" + this.guideData.latitude + "," + this.guideData.longitude + "|name:" + this.guideData.title + "&region=" + data.formattedAddress + "&mode=driving&output=html&coord_type=gcj02&src=zhjy"
}, (data) => {
this.gdMapUrl = "http://uri.amap.com/navigation?from="+ data.position.lng + "," + data.position.lat + ",我的位置&to=" + this.guideData.longitude + "," + this.guideData.latitude + "," + this.guideData.title + "&mode=car&policy=1&src=mypage&callnative=0"
this.txMapUrl = "https://map.qq.com/nav/drive#routes/page?eword=" + data.formattedAddress + "&noback=&referer=groupActivity_myapp&ch=mc_h5marker&start="+ data.position.lng + "," + data.position.lat + "&dest=" + this.guideData.latitude + "," + this.guideData.longitude + "&sword=我的位置"

this.bdMapUrl = "http://api.map.baidu.com/direction?origin=latlng:" + data.position.lat + "," + data.position.lng + "|name:我的起点&destination=latlng:" + this.guideData.latitude + "," + this.guideData.longitude + "|name:" + this.guideData.title + "&region=" + data.formattedAddress + "&mode=driving&output=html&coord_type=gcj02&src=zhjy"
})
},
closeMaplist: function(){
this.$emit("closeMapSec")
}
}
}
